const version = "7.13.1";
export {
  version
};
//# sourceMappingURL=package.json.js.map
